// Must come first: it rewrites legacy #/… URLs before ./router reads location.
import './legacy-hash'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import reveal from './directives/reveal'
import './assets/main.css'
import './assets/site.css'

createApp(App).use(router).directive('reveal', reveal).mount('#app')
